module.exports = __webpack_public_path__ + "img/EN-PLC-4.e446345f.png";